/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { J as isIOS } from '../../../index-f24a9ec1.js';
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

// 驿站JSBridge：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/share.html
function saveImage(params) {
    // ios下没有 TBSharedModule.saveMultiImage。
    // 所以目前根据端区分解决：https://code.alibaba-inc.com/cn-yz/m-post
    // TODO 推动驿站掌柜Native IOS和Android统一
    if (isIOS) {
        WVCall('TBSharedModule.saveImage', params, {
            formatInput: function (options) { return ({
                image: options.url,
            }); },
        });
    }
    else {
        WVCall('TBSharedModule.saveMultiImage', params, {
            formatInput: function (options) { return ({
                url: [options.url],
            }); },
        });
    }
}

export { saveImage as default };
